import { clsx } from 'clsx';
import type { CSSProperties } from 'react';

type Variant = 'text' | 'block' | 'circle';

const VARIANT: Record<Variant, string> = {
  text: 'h-3.5 rounded-md',
  block: 'rounded-md',
  circle: 'rounded-full',
};

export interface SkeletonProps {
  variant?: Variant;
  width?: string | number;
  height?: string | number;
  className?: string;
}

export function Skeleton({ variant = 'block', width, height, className }: SkeletonProps) {
  const style: CSSProperties = {
    width: width ?? (variant === 'text' ? '100%' : undefined),
    height: height ?? (variant === 'circle' ? width : undefined),
    background:
      'linear-gradient(90deg, var(--bg-card) 0%, var(--bg-elevated) 50%, var(--bg-card) 100%)',
    backgroundSize: '200% 100%',
    animation: 'ds-skeleton-shimmer 1.5s infinite linear',
  };
  return <div className={clsx(VARIANT[variant], className)} style={style} />;
}
